import axios from "axios";

import carto from "@carto/carto.js";
import cartodb from "@/constants/cartodb.js";

const {apiKey, username, serverUrl, cartoTable} = cartodb;
export default {
	client() {
		return new carto.Client({apiKey, username, serverUrl});
	},
	executeQuery(query) {
		return new Promise((resolve, reject) => {
			axios(serverUrl + "/api/v2/sql?q=" + query + "&api_key=" + apiKey)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	executeQueryWithBounds(query) {
		return new Promise((resolve, reject) => {
			axios(serverUrl + "/api/v2/sql?format=geojson&q=" + query + "&api_key=" + apiKey)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	executeQueryImport(urlFile) {
		return new Promise((resolve, reject) => {
			let payload = {
				create_vis: false,
				privacy: "LINK",
				type_guessing: true,
				content_guessing: true,
				interval: 0,
				url: urlFile,
			};
			let axiosConfig = {
				headers: {
					"Access-Control-Allow-Origin": "*",
					"Content-Type": "application/json",
					"Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
				},
			};

			axios
				.post(serverUrl + "/api/v1/imports/?api_key=" + apiKey, payload, axiosConfig)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	generateUpdateQuery(coordinates, cartodb_id) {
		let featureObj = {
			type: "Polygon",
			coordinates: [coordinates], // [[ [-91.23046875,45.460130637921], [-79.8046875,49.837982453085],[-69.08203125,43.452918893555],[-88.2421875,32.694865977875],[-91.23046875,45.460130637921] ]]
			crs: {type: "name", properties: {name: "EPSG:4326"}},
			properties: {
				description: "nuevo poligono para zipa",
				layer: "13",
				name: "nueva",
			},
		};
		const query = `UPDATE ${cartoTable} SET the_geom = ST_TRANSFORM(ST_GeomFromGeoJSON('${JSON.stringify(
			featureObj
		)}'),4326),
                        the_geom_webmercator = ST_TRANSFORM(ST_GeomFromGeoJSON('${JSON.stringify(
							featureObj
						)}'),3857) WHERE cartodb_id = ${cartodb_id}
        `;
		return query;
	},
	generateUpdateQueryZoneInfo({name, description, layer, cartodb_id}) {
		const query = `UPDATE ${cartoTable} SET name = '${name}', description = '${description}' WHERE  cartodb_id = ${cartodb_id} AND layer LIKE '${layer}';
                        `;
		return query;
	},
	generateCreateQuery({name, description, layer, the_geom, the_geom_webmercator}) {
		const query = `INSERT INTO ${cartoTable} (the_geom , the_geom_webmercator , name, description, layer)
                        VALUES (ST_TRANSFORM(ST_GeomFromGeoJSON('${JSON.stringify(the_geom)}'),4326),
                        ST_TRANSFORM(ST_GeomFromGeoJSON('${JSON.stringify(the_geom_webmercator)}'),3857),
                        '${name}',
                        '${description}',
                        '${layer}')
                        `;
		return query;
	},
	generateCreateTableQuery() {
		return `CREATE TABLE ${cartoTable} (name TEXT,description TEXT,layer TEXT); SELECT cdb_cartodbfytable('${cartoTable}')`;
	},
	generateDeleteZoneQuery(layer, cartodbIds) {
		const query = `DELETE FROM ${cartoTable} WHERE cartodb_id IN (${cartodbIds}) AND layer LIKE '${layer}'`;
		return query;
	},
	generateDeleteAllZonesQuery(layer) {
		const query = `DELETE FROM ${cartoTable} WHERE layer LIKE '${layer}'`;
		return query;
	},
	generateCartoCSS(polygonFill = "FF6600") {
		// Create style for the data
		return new carto.style.CartoCSS(`
          #layer {
          polygon-fill: ${polygonFill};
            polygon-opacity: 0.5;
            line-color: #FFFFFF;
            line-width: 0.5;
            line-opacity: 1;
            line-dasharray: 10, 5;
          }
        `);
	},
	validateCreateTableQuery() {
		return `SELECT EXISTS (SELECT FROM pg_tables WHERE schemaname = 'public' AND tablename = '${cartoTable}')`;
	},
};
